import type React from 'react';

import { AttentionCircleIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';

import st from './GroupAvailabilityConfirmation.module.sass';
import { useCheckGroupAvailabilityTranslation } from './i18n';

export interface GroupAvailabilityConfirmationProps {
  groupName: string;
  permissionTag: string;
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

export function GroupAvailabilityConfirmation({
  groupName,
  permissionTag,
  onConfirm,
  onReject,
}: GroupAvailabilityConfirmationProps): React.JSX.Element {
  const { t } = useCheckGroupAvailabilityTranslation();

  return (
    <div className={st.GroupAvailabilityConfirmation}>
      <div className={st.Header}>
        <AttentionCircleIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>
            {t('title')}
          </span>
          <span className={st.Details}>
            {t('details', {
              groupName,
              permissionTag,
            })}
          </span>
        </div>
      </div>

      <div className={st.Actions}>
        <Button
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('reject')}
        </Button>
        <Button
          kind="attention"
          onClick={onConfirm}
          variant="filled"
        >
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
}
